module.exports = __webpack_public_path__ + "static/media/arslan-abayev.151563a8.jpg";